module.exports = __webpack_public_path__ + "images/02293b64.jpg";